export default __webpack_public_path__ + "static/media/SVG5.2daa3489.svg";